import { DateRangeFilter } from '@/features/common/DateRangeFilter/DateRangeFilter';
import { useFilterPanelControl } from '@/features/common/FilterPanel/filterPanelControls';
import type { FilterDateRangeProps } from '@/features/common/FilterPanel/types/FilterDateRangeProps';

/** A labelled period in a FilterPanel — DateRangeFilter, a list-like trigger opening onto two MUD
 * date inputs. */
export function FilterDateRange({
  name,
  label,
  ariaLabel,
  placeholder,
  from,
  to,
  onChange,
}: FilterDateRangeProps) {
  const control = useFilterPanelControl(name);
  return (
    <div className="filter-panel__field">
      <span className="filter-panel__label">{label}</span>
      <DateRangeFilter
        ariaLabel={ariaLabel}
        placeholder={placeholder}
        from={from}
        to={to}
        onChange={onChange}
        {...control}
      />
    </div>
  );
}
